var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('base-typography',{staticClass:"ellipsis",attrs:{"value":_vm.showText,"title":_vm.showText,"color":_vm.color,"single":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }